import type { GenerationMethod, ModalId } from '@heidi/schema/ml-scribe';

import type { useQueryTemplateById as useQueryTemplateByIdCore } from '../../data/query/useQueryTemplateById';

export interface TemplateBuilderRouter {
  pathname: string;
  push: (href: string) => Promise<boolean>;
}

export interface TemplateBuilderPorts {
  useRouter(): TemplateBuilderRouter;
  useQueryTemplateById(
    id: string | null | undefined,
    method: GenerationMethod | null | undefined
  ): ReturnType<typeof useQueryTemplateByIdCore>;
  useMutateMarkModalAsViewed(): {
    mutate: (value: { modal_id: ModalId; increment_count: boolean }) => void;
  };
  useCurrentQueuedModal(): object | null;
  canManageTemplateSharing(): boolean;
}

let ports: TemplateBuilderPorts | null = null;

export const configureTemplateBuilderPorts = (next: TemplateBuilderPorts): void => {
  ports = next;
};

export const getTemplateBuilderPorts = (): TemplateBuilderPorts => {
  if (!ports) {
    throw new Error(
      '[templates/template-builder-ports] ports not configured — the app must load ' +
        "'@/utils/templates-data-wiring' at bootstrap; tests must call " +
        'configureTemplateBuilderPorts() with a double first.'
    );
  }
  return ports;
};

export const resetTemplateBuilderPortsForTests = (): void => {
  ports = null;
};
